import React, { useContext } from 'react';
import { Routes, Route, Navigate, useResolvedPath } from 'react-router-dom';
import UpsellRoutes from 'Sell/Upsell/Router/routes';
import RoomTypeList from 'Sell/Upsell/RoomType/List/RoomTypeList';
import UpsertRoomType from 'Sell/Upsell/RoomType/Upsert/UpsertRoomType';
import UpsellList from 'Sell/Upsell/Upsell/List/UpsellList';
import Reports from 'Sell/Upsell/Reports/Reports';
import ProtectedRoute from 'Sell/Upsell/Shell/ProtectedRoute';
import { AppContext } from 'App.context';

export default function NestedRoutes() {
  const { appState } = useContext(AppContext);
  const resolved = useResolvedPath('.');
  const basePath = resolved.pathname;

  const defaultRoute =
    appState.role === 'owner' || appState.role === 'admin' || appState.superUser
      ? `${basePath}${UpsellRoutes.roomsList}`
      : `${basePath}${UpsellRoutes.upsellsList}`;

  return (
    <Routes>
      <Route
        path={`${UpsellRoutes.roomsList}`}
        element={
          <ProtectedRoute>
            <RoomTypeList />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${UpsellRoutes.roomCreate}`}
        element={
          <ProtectedRoute>
            <UpsertRoomType />
          </ProtectedRoute>
        }
      />
      <Route
        path={`${UpsellRoutes.roomUpsert}`}
        element={
          <ProtectedRoute>
            <UpsertRoomType />
          </ProtectedRoute>
        }
      />
      <Route path={`${UpsellRoutes.upsellsList}`} element={<UpsellList />} />
      <Route path={`${UpsellRoutes.reports}`} element={<Reports />} />
      <Route path="*" element={<Navigate to={defaultRoute} replace />} />
    </Routes>
  );
}